export const state = () => ({
	advanced_questions: [],
	advanced_question: null,
	types: [],
	input_types: [],
});

export const mutations = {
	setAdvancedQuestions(state: any, payload: any) {
		state.advanced_questions = payload;
	},

	setAdvancedQuestion(state: any, payload: any) {
		state.advanced_question = payload;
	},

	setTypes(state: any, payload: any) {
		state.types = payload;
	},

	setInputTypes(state: any, payload: any) {
		state.input_types = payload;
	},
};

export const getters = {
	getAdvancedQuestions: (state: any) => state.advanced_questions,
	getAdvancedQuestion: (state: any) => state.advanced_question,
	getTypes: (state: any) => state.types,
	getInputTypes: (state: any) => state.input_types,
};

export const actions = {
	getTypes(state: any) {
		return new Promise((resolve, reject) => {
			if (state.state.types.length) {
				resolve(state.state.types);
			}

			this.$axios
				.get('/api/jobs/questions/types')
				.then((res) => {
					state.commit('setTypes', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getInputTypes(state: any) {
		return new Promise((resolve, reject) => {
			if (state.state.input_types.length) {
				resolve(state.state.input_types);
			}

			this.$axios
				.get('/api/jobs/questions/input-types')
				.then((res) => {
					state.commit('setInputTypes', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	storeAdvancedQuestion(state: any, payload: any) {
		const { job_uuid, ...data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.post(`/api/jobs/${job_uuid}/questions`, data)
				.then((res) => {
					let questions = [...state.state.advanced_questions];

					questions.push(res.data);

					state.commit('setAdvancedQuestions', questions);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	editAdvancedQuestion(state: any, payload: any) {
		const { uuid, ...data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/jobs/questions/' + uuid, data)
				.then((res) => {
					let questions = [...state.state.advanced_questions];
					let index = questions.findIndex((item) => item.uuid === uuid);

					questions.splice(index, 1);
					questions.splice(index, 0, res.data);

					state.commit('setAdvancedQuestions', questions);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	deleteAdvancedQuestion(state: any, question_uuid: string) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete('/api/jobs/questions/' + question_uuid)
				.then((res) => {
					let questions = [...state.state.advanced_questions];

					questions = questions.filter((item) => item.uuid !== question_uuid);

					state.commit('setAdvancedQuestions', questions);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateAdvancedQuestions(state: any, payload: any) {
		state.commit('setAdvancedQuestions', payload);
	},

	updateAdvancedQuestion(state: any, payload: any) {
		state.commit('setAdvancedQuestion', payload);
	},
};
